<div id="todo" class="page-layout carded left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header  p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">{{'CONSULTATABLA.LOG_SISTEMA.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [ngClass]="">

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar primary px-24 py-8">
                <span>Log:</span>
            </div>

            <div class="content" fxLayout="column" fxLayoutAlign="start stretch" class="p-20" fusePerfectScrollbar>
                <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
                    <div fxFlex="50">
                        <mat-form-field appearance="outline" fxFlex>
                            <mat-label>{{'CONSULTATABLA.LOG_SISTEMA.BUSCADOR' | translate}}</mat-label>
                            <input matInput [(ngModel)]='search' (keyup)="cargarLogs(1)" placeholder="{{'CONSULTATABLA.LOG_SISTEMA.PLACEHOLDER' | translate}}">
                        </mat-form-field>

                    </div>
                    <div fxFlex="50" fxLayout="row" fxLayoutAlign="end center">
                        <button mat-icon-button (click)="cargarLogs(prevPage)" [disabled]="!anterior">
                      <mat-icon>keyboard_arrow_left</mat-icon>
                    </button>
                    <h3>{{'CONSULTATABLA.LOG_SISTEMA.PAGINA' | translate}} {{pagina}}</h3>
                        <button mat-icon-button (click)="cargarLogs(nextPage)">
                      <mat-icon>keyboard_arrow_right</mat-icon>
                    </button>

                    <button mat-fab color="primary" (click)="cargarLogs(1)" matTooltip="{{'CONSULTATABLA.LOG_SISTEMA.ACTUALIZAR' | translate}}">
                    <mat-icon>update</mat-icon>
                    </button>
                    </div>

                </div>

                <ng-container *ngIf="cargando">
                    <div fxLayout="column" fxLayoutAlign="space-between center">
                        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                        <h1>{{'CONSULTATABLA.LOG_SISTEMA.CARGA' | translate}}</h1>
                    </div>
                </ng-container>

            <table mat-table [dataSource]="logs" class="mat-elevation-z8" *ngIf="!cargando">
               <!-- Position Column -->
               <ng-container matColumnDef="imagen">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.IMAGEN' | translate}} </th>
                 <td mat-cell style="width: 10%;" *matCellDef="let log">
                   <img *ngIf="log.companyCGO != null" class="logoCliente" src="{{logo+log.companyCGO.datosEmpresa.logoEmpresa}}" alt="">
                   <label *ngIf="log.companyCGO == null" class="label label-success  centrar">
                     -----------
                   </label>
                 </td>
               </ng-container>

               <!-- Name Column -->
               <ng-container matColumnDef="ipcliente">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.IP' | translate}} </th>
                 <td mat-cell *matCellDef="let log"> {{ log.host }} </td>
               </ng-container>

               <!-- Weight Column -->
               <ng-container matColumnDef="usuario">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.USER' | translate}} </th>
                 <td mat-cell *matCellDef="let log">
                   <label *ngIf="log.userCGO != null"> {{ log.userCGO.user }} </label>
                   <label *ngIf="log.userCGO == null" class="label label-success  centrar">
                     -----------
                   </label>
                 </td>
               </ng-container>

               <!-- Symbol Column -->
               <ng-container matColumnDef="empresa">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.COMPANY' | translate}} </th>
                 <td mat-cell *matCellDef="let log">
                   <label *ngIf="log.companyCGO != null"> {{ log.companyCGO.datosEmpresa.nombreEmpresa }} </label>
                   <label *ngIf="log.companyCGO == null" class="label label-success centrar">
                     -----------
                   </label>
                 </td>
               </ng-container>

               <ng-container matColumnDef="plataforma">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.PLATFORM' | translate}} </th>
                 <td mat-cell *matCellDef="let log">
                   <label *ngIf="log.platform === 'CGO'">Cultural GO 5.0</label>
                   <!-- <img *ngIf="log.platform === 'CGO'" src="assets/images/logo-cgo.png" alt="homepage" class="dark-logo img-50 espacios" /> -->
                 </td>
               </ng-container>

               <!-- Name Column -->
               <ng-container matColumnDef="estatus">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.STATUS' | translate}} </th>
                 <td mat-cell *matCellDef="let log">
                   <label *ngIf="!log.success" class="error">
                       Error
                   </label>
                   <label *ngIf="log.success" class="success">
                       Success
                   </label>
                 </td>
               </ng-container>

               <!-- Weight Column -->
               <ng-container matColumnDef="resultado">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.RESULT' | translate}} </th>
                 <td mat-cell *matCellDef="let log">
                   <label *ngIf="!log.success">
                       {{ log.error }}
                   </label>
                   <label *ngIf="log.success">
                       {{ log.action }}
                   </label>
                 </td>
               </ng-container>

               <!-- Symbol Column -->
               <ng-container matColumnDef="fecha">
                 <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SISTEMA.TABLA.DATE' | translate}} </th>
                 <td mat-cell *matCellDef="let log"> {{log.createdAt}} </td>
               </ng-container>

               <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
               <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
             </table>
             </div>

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
